import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import api from '@/api'
import router from '@/router'
Vue.use(Vuex)
const service = axios.create({
  baseURL: window.global.RequestBaseUrl,
  withCredentials: true, // 跨域支持发送cookie
  timeout: window.global.RequestTimeout // 请求超时时间
})
var admintoken = localStorage.getItem('ats_admintoken')

const store = new Vuex.Store({
	state: {
		userinfo:{},
    loginStatus: true
	},
	// 修改状态
	mutations: {
	    setUserinfo (state, data) {
	      state.userinfo = data
	      state.userinfo.access_array = [] 
	      if(state.userinfo.access!='all'){
	      	let access_arr = state.userinfo.access.checkedKeys.concat(state.userinfo.access.harfCheckedKeys)
	      	for (var i = 0; i < access_arr.length; i++) {
	      		state.userinfo.access_array.push(access_arr[i])
	      	}
	      }
	    },
	    setLoginStatus (state, data) {
	      state.loginStatus = data
	    }
	},
	actions:{
		doLogin (context, value) {
			context.commit('setLoginStatus',value)
		},
		getUserinfo (context, value) {
			return new Promise((resolve, reject) => {
				service({
				  method: 'GET',
				  headers: {
				    'qscmsadmintoken': admintoken,
				  },
				  url: api.userinfo,
				  data: {}
				})
				  .then((res) => {
				  	if(res.data.code==50001){
				  		context.commit('setLoginStatus',false)
				  	}else{
				  		context.commit('setLoginStatus',true)
				    	context.commit('setUserinfo', res.data.data)
				  	}
				    resolve(res.data.data)
				  })
				  .catch((error) => {
				    reject(error)
				  })
			})
		},
	}
})

export default store
